<template>
  <div class="basic-header" :class="{ 'header-sticky': isSticky }">
    <div class="header-logo">
      <img src="@/assets/images/logo.png" alt="" />
    </div>

    <!-- PC端菜单 -->
    <div class="header-menu" v-if="!isMobile">
      <div
        class="header-menu-item"
        v-for="(item, index) in pcMenu"
        :key="index"
        :class="{ active: activeMenuName == item.name }"
        @click="handlePCMenuClick(item)"
      >
        <span>{{ item.title }}</span>
      </div>
    </div>

    <!-- 移动端汉堡菜单按钮 -->
    <div class="mobile-menu-btn" v-if="isMobile" @click="toggleSideMenu">
      <i class="el-icon-menu"></i>
    </div>

    <!-- 移动端侧滑菜单 -->
    <el-drawer
      v-if="isMobile"
      :visible.sync="sideMenuVisible"
      direction="rtl"
      size="80%"
      :with-header="false"
      :modal="false"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      :append-to-body="true"
      :lock-scroll="false"
      :z-index="9999"
      class="mobile-side-menu"
      @close="handleDrawerClose"
    >
      <div class="side-menu-header">
        <span class="menu-title">标准日本语</span>
        <button class="close-btn" @click="closeSideMenu" aria-label="关闭菜单">
          <i class="el-icon-close"></i>
        </button>
      </div>
      <div class="side-menu-content">
        <div
          class="side-menu-item"
          v-for="(item, index) in mobileMenu"
          :key="index"
          :class="{ active: activeMenuName == item.name }"
          @click="handleMenuClick(item)"
          @touchstart="handleTouchStart"
          @touchend="handleTouchEnd"
        >
          <span>{{ item.title }}</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>

      <!-- 移动端底部操作区域 -->
      <div class="side-menu-footer">
        <div class="footer-info">
          <p>标日电子书</p>
          <p>让学习更简单</p>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { check_browser } from "@/utils";

export default {
  name: "BasicLayoutHeader",
  data() {
    return {
      menu: [
        {
          path: "/main/home",
          name: "Home",
          title: "首页",
        },
        {
          path: "/main/info",
          name: "Info",
          title: "信息查询",
        },
        {
          path: "/login",
          name: "Login",
          title: "登录",
        },
        {
          path: "/main/help",
          name: "Help",
          title: "帮助",
        },
      ],
      sideMenuVisible: false,
      touchStartTime: 0,
      screenWidth: window.innerWidth,
      forceMobile: false, // 强制移动端模式
      isSticky: false, // 吸顶状态
      scrollThreshold: 50, // 降低吸顶触发阈值，让移动端更容易触发
    };
  },
  computed: {
    activeMenuName() {
      return this.$route.name;
    },
    deviceType() {
      return check_browser();
    },
    isMobile() {
      // 使用多种方法检测移动端
      const isMobileByUA = check_browser() !== "pc";
      const isMobileByWidth = this.screenWidth <= 768;
      const isMobileByTouch = "ontouchstart" in window;

      // 如果任一条件满足，认为是移动端
      return (
        this.forceMobile || isMobileByUA || isMobileByWidth || isMobileByTouch
      );
    },
    isDevelopment() {
      return process.env.NODE_ENV === "development";
    },
    // 根据当前路由动态返回菜单
    dynamicMenu() {
      const currentPath = this.$route.path;

      // 如果是 gaokao 相关页面，显示学习相关菜单
      if (currentPath.startsWith("/gaokao")) {
        return [
          {
            path: "/main/home",
            name: "Home",
            title: "返回首页",
          },
          {
            path: "/gaokao/list",
            name: "GaokaoList",
            title: "图书激活",
          },
          {
            path: "/gaokao/search",
            name: "GaokaoSearch",
            title: "账号查询",
          },
          {
            path: "/gaokao/courseware",
            name: "GaokaoCourseware",
            title: "课件学习",
          },
          {
            path: "/logout",
            name: "Logout",
            title: "退出登录",
            action: "logout",
          },
        ];
      }

      // 默认菜单
      return [
        {
          path: "/main/home",
          name: "Home",
          title: "首页",
        },
        {
          path: "/main/info",
          name: "Info",
          title: "信息查询",
        },
        {
          path: "/login",
          name: "Login",
          title: "登录",
        },
        {
          path: "/main/help",
          name: "Help",
          title: "帮助",
        },
      ];
    },
    // PC端菜单保持不变
    pcMenu() {
      return [
        {
          path: "/main/home",
          name: "Home",
          title: "首页",
        },
        {
          path: "/main/info",
          name: "Info",
          title: "信息查询",
        },
        {
          path: "/login",
          name: "Login",
          title: "登录",
        },
        {
          path: "/main/help",
          name: "Help",
          title: "帮助",
        },
      ];
    },
    // 移动端侧滑菜单
    mobileMenu() {
      const currentPath = this.$route.path;
      if (currentPath.startsWith("/gaokao")) {
        return [
          {
            path: "/main/home",
            name: "Home",
            title: "返回首页",
          },
          {
            path: "/gaokao/list",
            name: "GaokaoList",
            title: "图书激活",
          },
          {
            path: "/gaokao/search",
            name: "GaokaoSearch",
            title: "账号查询",
          },
          {
            path: "/gaokao/courseware",
            name: "GaokaoCourseware",
            title: "课件学习",
          },
          {
            path: "/logout",
            name: "Logout",
            title: "退出登录",
            action: "logout",
          },
        ];
      }
      return [
        {
          path: "/main/home",
          name: "Home",
          title: "首页",
        },
        {
          path: "/main/info",
          name: "Info",
          title: "信息查询",
        },
        {
          path: "/login",
          name: "Login",
          title: "登录",
        },
        {
          path: "/main/help",
          name: "Help",
          title: "帮助",
        },
      ];
    },
  },
  created() {
    // 监听窗口大小变化
    window.addEventListener("resize", this.handleResize);
  },
  mounted() {
    // 监听路由变化，自动关闭侧滑菜单
    this.$router.afterEach(() => {
      if (this.sideMenuVisible) {
        this.closeSideMenu();
      }
    });

    // 添加滚动监听
    this.addScrollListener();

    // 输出调试信息
    console.log("Header组件挂载完成");
    console.log("设备类型:", this.deviceType);
    console.log("屏幕宽度:", this.screenWidth);
    console.log("是否为移动端:", this.isMobile);
    console.log("User Agent:", navigator.userAgent);
  },
  beforeDestroy() {
    // 清理事件监听器
    window.removeEventListener("resize", this.handleResize);
    this.removeScrollListener();
  },
  methods: {
    handleResize() {
      this.screenWidth = window.innerWidth;
      console.log("窗口大小变化:", this.screenWidth);
    },
    addScrollListener() {
      // 使用节流函数优化滚动性能
      let ticking = false;
      this.scrollHandler = () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            this.handleScroll();
            ticking = false;
          });
          ticking = true;
        }
      };

      window.addEventListener("scroll", this.scrollHandler, { passive: true });
    },
    removeScrollListener() {
      if (this.scrollHandler) {
        window.removeEventListener("scroll", this.scrollHandler);
      }
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const shouldBeSticky = scrollTop > this.scrollThreshold;

      // 添加详细的调试信息
      if (this.isDevelopment) {
        console.log("滚动信息:", {
          scrollTop,
          threshold: this.scrollThreshold,
          shouldBeSticky,
          currentSticky: this.isSticky,
          isMobile: this.isMobile,
        });
      }

      if (this.isSticky !== shouldBeSticky) {
        this.isSticky = shouldBeSticky;
        console.log("吸顶状态变化:", this.isSticky, "滚动位置:", scrollTop);

        // 在开发环境下显示提示
        if (this.isDevelopment) {
          this.$message({
            message: this.isSticky
              ? `已触发吸顶 (${scrollTop}px)`
              : `已取消吸顶 (${scrollTop}px)`,
            type: this.isSticky ? "success" : "info",
            duration: 2000,
          });
        }
      }
    },
    toggleSticky() {
      this.isSticky = !this.isSticky;
      console.log("手动切换吸顶状态:", this.isSticky);
      this.$message({
        message: this.isSticky ? "已启用吸顶模式" : "已关闭吸顶模式",
        type: "success",
        duration: 2000,
      });
    },
    forceMobileMode() {
      this.forceMobile = !this.forceMobile;
      console.log("强制移动端模式:", this.forceMobile);
      this.$message({
        message: this.forceMobile
          ? "已启用强制移动端模式"
          : "已关闭强制移动端模式",
        type: "success",
        duration: 2000,
      });
    },
    toggleMenu() {
      this.toggleSideMenu();
    },
    toggleSideMenu() {
      this.sideMenuVisible = !this.sideMenuVisible;
      console.log("切换侧滑菜单:", this.sideMenuVisible);
    },
    closeSideMenu() {
      this.sideMenuVisible = false;
    },
    handleMenuClick(item) {
      // 如果是退出登录，执行退出逻辑
      if (item.action === "logout") {
        this.handleLogout();
        return;
      }

      // 正常路由跳转
      this.$router.push(item.path);
      this.closeSideMenu();
    },
    handlePCMenuClick(item) {
      // 如果是退出登录，执行退出逻辑
      if (item.action === "logout") {
        this.handleLogout();
        return;
      }

      // 正常路由跳转
      this.$router.push(item.path);
    },

    // 处理退出登录
    handleLogout() {
      this.$confirm("确定要退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 清除用户信息
          localStorage.removeItem("rypc_userInfo");
          localStorage.removeItem("rypc_token");
          sessionStorage.removeItem("rypc_book");

          // 清除 store 中的用户信息
          this.$store.dispatch("logOut");

          // 跳转到首页
          this.$router.push("/main/home");

          this.$message({
            type: "success",
            message: "已成功退出登录",
          });

          this.closeSideMenu();
        })
        .catch(() => {
          // 用户取消退出
        });
    },
    handleDrawerClose() {
      this.sideMenuVisible = false;
    },
    handleTouchStart() {
      this.touchStartTime = Date.now();
    },
    handleTouchEnd() {
      const touchDuration = Date.now() - this.touchStartTime;
      // 如果触摸时间很短，认为是点击
      if (touchDuration < 200) {
        // 添加触摸反馈
        // this.$message({
        //   message: '正在跳转...',
        //   type: 'success',
        //   duration: 1000,
        //   showClose: false
        // });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.basic-header {
  max-width: 1200px;
  min-width: 1042px;
  width: 100%;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  overflow-x: hidden;
  transition: all 0.3s ease; // 添加过渡动画

  .header-logo {
    img {
      margin-left: 30px;
      max-width: 100%;
      transition: filter 0.3s ease;
    }
  }

  //移动端汉堡菜单按钮
  .mobile-menu-btn {
    display: none;
    cursor: pointer;
    padding: 8px;
    transition: all 0.3s ease;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);

    &:hover {
      background: rgba(255, 255, 255, 0.2);
    }

    &:active {
      transform: scale(0.95);
    }

    i {
      font-size: 24px;
      color: #fff;
      transition: color 0.3s ease;
    }
  }
}

// 吸顶动画
@keyframes slideDown {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

// 移动端样式 - 使用更宽松的断点
@media (max-width: 1024px) {
  .basic-header {
    min-width: auto !important;
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 15px !important;
    margin: 0 !important;
    overflow-x: hidden !important;

    // 移动端吸顶样式优化 - 使用更高优先级
    &.header-sticky {
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      z-index: 9999 !important;
      padding: 0 15px !important;
      background: rgba(255, 255, 255, 0.98) !important;
      backdrop-filter: blur(15px) !important;
      -webkit-backdrop-filter: blur(15px) !important;
      box-shadow: 0 2px 15px rgba(0, 0, 0, 0.15) !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: auto !important;

      .mobile-menu-btn {
        background: rgba(0, 0, 0, 0.1) !important;
        border-color: rgba(0, 0, 0, 0.2) !important;

        i {
          color: #333 !important;
        }
      }
    }

    .header-logo {
      img {
        margin-left: 0 !important;
        height: 40px !important;
        max-width: 100% !important;
      }
    }

    .mobile-menu-btn {
      display: block !important;
    }
  }
}

// 强制显示移动端按钮的样式
.basic-header .mobile-menu-btn {
  display: none;
}

@media (max-width: 1024px) {
  .basic-header .mobile-menu-btn {
    display: block !important;
  }
}

// 小屏幕设备优化
@media (max-width: 768px) {
  .basic-header {
    padding: 0 10px !important;

    &.header-sticky {
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      z-index: 9999 !important;
      padding: 0 10px !important;
      background: rgba(255, 255, 255, 0.99) !important;
      backdrop-filter: blur(20px) !important;
      -webkit-backdrop-filter: blur(20px) !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: auto !important;
    }

    .header-logo img {
      height: 35px !important;
    }

    .mobile-menu-btn {
      margin-right: 10px !important;
      padding: 6px !important;

      i {
        font-size: 20px !important;
      }
    }
  }
}

// 超小屏幕设备优化
@media (max-width: 480px) {
  .basic-header {
    padding: 0 8px !important;

    &.header-sticky {
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      z-index: 9999 !important;
      padding: 0 8px !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: auto !important;
    }

    .header-logo img {
      height: 30px !important;
    }

    .mobile-menu-btn {
      line-height: 18px;
      margin-right: 8px !important;
      padding: 5px !important;

      i {
        font-size: 18px !important;
      }
    }
  }
}

// 侧滑菜单样式
.mobile-side-menu {
  .side-menu-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 88px;
    padding: 0 20px;
    border-bottom: 1px solid #eee;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);

    .menu-title {
      color: #fff;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 0.5px;
      text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    }

    .close-btn {
      background: none;
      border: none;
      font-size: 20px;
      cursor: pointer;
      color: #fff;
      padding: 6px;
      border-radius: 50%;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;

      &:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: rotate(90deg);
      }

      &:focus {
        outline: none;
        box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3);
      }

      &:active {
        transform: rotate(90deg) scale(0.95);
      }
    }
  }

  .side-menu-content {
    padding: 20px 0;
    flex: 1;

    .side-menu-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 18px 20px;
      cursor: pointer;
      transition: all 0.3s ease;
      border-bottom: 1px solid #f5f5f5;
      position: relative;
      overflow: hidden;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          90deg,
          transparent,
          rgba(255, 255, 255, 0.1),
          transparent
        );
        transition: left 0.5s;
      }

      &:hover::before {
        left: 100%;
      }

      &:hover {
        background: #f8f9fa;
        transform: translateX(5px);
      }

      &:active {
        transform: translateX(5px) scale(0.98);
      }

      &.active {
        background: linear-gradient(90deg, #e6f7ff, #f0f9ff);
        color: #1890ff;
        border-right: 3px solid #1890ff;
      }

      span {
        font-size: 16px;
        font-weight: 500;
        flex: 1;
      }

      i {
        color: #999;
        transition: all 0.3s ease;
      }

      &:hover i {
        color: #1890ff;
        transform: translateX(5px);
      }
    }
  }

  .side-menu-footer {
    padding: 20px;
    border-top: 1px solid #eee;
    background: #f8f9fa;

    .footer-info {
      text-align: center;

      p {
        margin: 5px 0;
        color: #666;
        font-size: 14px;

        &:first-child {
          font-weight: bold;
          color: #333;
        }
      }
    }
  }
}

// 移动端侧滑菜单响应式优化
@media (max-width: 768px) {
  .mobile-side-menu {
    .side-menu-header {
      height: 60px !important;
      padding: 0 16px !important;

      .menu-title {
        font-size: 15px !important;
        letter-spacing: 0.3px !important;
      }

      .close-btn {
        width: 28px !important;
        height: 28px !important;
        font-size: 18px !important;
        padding: 4px !important;
      }
    }
  }
}

@media (max-width: 480px) {
  .mobile-side-menu {
    .side-menu-header {
      height: 56px !important;
      padding: 0 16px !important;

      .menu-title {
        font-size: 14px !important;
        letter-spacing: 0.2px !important;
      }

      .close-btn {
        width: 26px !important;
        height: 26px !important;
        font-size: 16px !important;
        padding: 3px !important;
      }
    }
  }
}

@media (max-width: 320px) {
  .mobile-side-menu {
    .side-menu-header {
      height: 52px !important;
      padding: 0 12px !important;

      .menu-title {
        font-size: 13px !important;
        letter-spacing: 0px !important;
      }

      .close-btn {
        width: 24px !important;
        height: 24px !important;
        font-size: 14px !important;
        padding: 2px !important;
      }
    }
  }
}

// 响应式断点
@media (max-width: 1042px) {
  .basic-header {
    min-width: auto !important;
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 20px !important;
    overflow-x: hidden !important;
  }
}

// 触摸设备优化
@media (hover: none) and (pointer: coarse) {
  .side-menu-item {
    &:hover {
      background: #f8f9fa !important;
    }

    &:active {
      background: #e9ecef !important;
      transform: scale(0.98) !important;
    }
  }
}

// 确保在所有设备上都没有水平滚动
@media (max-width: 1200px) {
  .basic-header {
    overflow-x: hidden !important;
  }
}

// 全局吸顶样式覆盖 - 确保优先级最高
.basic-header.header-sticky {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 9999 !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: auto !important;
}
</style>
